/* eslint no-underscore-dangle: 0 */
import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import mapTimeZoneToCountry from '../../../utils/timezone'

/**
 * Render a convertion
 */
const Convertion = ({ convertionEvent, deliveryAddress, reference }) => {
    if (convertionEvent == null) {
        return null
    }

    const isConvertedToInstabox = convertionEvent.event.event === 'ORDER_CONVERTED_TO_INSTABOX'

    const commentText = (
        <span>
            {isConvertedToInstabox
                ? 'This order has been converted to another system and should be handled there: '
                : 'This order was converted from another system. '}
            <a
                href={`https://console.instadmin.net/servo/orders/${reference._order}`}
                target="_blank"
                rel="noopener noreferrer"
            >
                {isConvertedToInstabox
                    ? 'View updated order in Servo.'
                    : 'View previous order in Servo.'}
            </a>
        </span>
    )

    return (
        <div>
            <p><label className="strong-label">Date</label>
            {moment(convertionEvent.timestamp)
                .tz(mapTimeZoneToCountry(deliveryAddress.countryCode))
                .format('YYYY-MM-DD HH:mm:ss')}
            </p>
            <p><label className="strong-label">{isConvertedToInstabox
                ? 'This order has been converted '
                : 'This order was converted '}</label>
            {commentText}
            </p>
        </div>
    )
}

export default Convertion

Convertion.propTypes = {
    convertionEvent: PropTypes.object.isRequired,
    deliveryAddress: PropTypes.object.isRequired,
    reference: PropTypes.object.isRequired
}
